const cornerLength = 8
const cornerShift = 3
const cornerLineWidth = 2
const dashedBorderType = [3, 3]
const dashedBorderWidth = 1
const rotateButtonRadius = 10
const deleteButtonRadius = 20
const deleteButtonLineWidth = 7

const cornerLineColor = '#efefef'
const dashedBorderColor = 'rgba(255, 255, 255, .8)'
const dashedBorderBackground = 'rgba(0, 0, 0, .8)'
const selectedItemBorderColor = '#265ECA'
const selectedItemSecondBorderColor = '#AACCFE'
const focusedLineColor = '#c10000'
const deleteButtonLineColor = '#8a94a0'
const deleteButtonColor = '#ffffff'
const rotateButtonColor = '#ffffff'
const textColor = '#000000'
const cursorColor = '#b4b4b4'

export const renderers = {
  line: (canvas, { boundary, border, focused, selected }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!border) return

    canvas.beginPath()
    canvas.lineWidth = selected ? border.width * 1.5 : border.width
    canvas.strokeStyle = focused ? focusedLineColor : border.color

    canvas.moveTo(boundary.x, boundary.y)
    canvas.lineTo(boundary.x + boundary.width, boundary.y + boundary.height)
    canvas.stroke()
    canvas.closePath()
  },

  selectionLine: (canvas, { boundary, hasRemoveIcon }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!hasRemoveIcon) return

    //drawing of circle
    canvas.beginPath()
    canvas.fillStyle = deleteButtonColor
    canvas.arc(
      boundary.x + boundary.width,
      boundary.y + boundary.height,
      deleteButtonRadius,
      0,
      2 * Math.PI,
    )
    canvas.fill()
    canvas.closePath()

    //draving of 'X'
    canvas.beginPath()
    canvas.lineWidth = 2
    canvas.strokeStyle = deleteButtonLineColor
    canvas.moveTo(
      boundary.x + boundary.width - deleteButtonLineWidth,
      boundary.y + boundary.height - deleteButtonLineWidth,
    )
    canvas.lineTo(
      boundary.x + boundary.width + deleteButtonLineWidth,
      boundary.y + boundary.height + deleteButtonLineWidth,
    )
    canvas.moveTo(
      boundary.x + boundary.width + deleteButtonLineWidth,
      boundary.y + boundary.height - deleteButtonLineWidth,
    )
    canvas.lineTo(
      boundary.x + boundary.width - deleteButtonLineWidth,
      boundary.y + boundary.height + deleteButtonLineWidth,
    )
    canvas.stroke()
    canvas.closePath()
  },

  capArrow: (canvas, { boundary, triangle, focused }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!triangle) return

    let arrowW = triangle.width
    let arrowH = triangle.height

    const lineH = (boundary.width ** 2 + boundary.height ** 2) ** (1 / 2)
    if (lineH <= triangle.height) {
      arrowH = lineH ** 2 / triangle.height
      arrowW = (triangle.width * lineH) / triangle.height
    }

    let angle = Math.atan(-boundary.width / boundary.height)
    if (boundary.width === 0 && boundary.height === 0) angle = 0
    if (boundary.height < 0) angle += Math.PI

    canvas.beginPath()
    canvas.fillStyle = focused ? focusedLineColor : triangle.fill

    canvas.translate(boundary.x, boundary.y)
    canvas.rotate(angle)

    canvas.moveTo(0, 0)
    canvas.lineTo(arrowW, arrowH)
    canvas.lineTo(-arrowW, arrowH)
    canvas.fill()

    canvas.rotate(-angle)
    canvas.translate(-boundary.x, -boundary.y)
    canvas.closePath()
  },

  rect: (canvas, { boundary, border, fill }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!border) return
    if (!fill) return

    ///drawing of rect
    canvas.beginPath()
    canvas.translate(boundary.x + boundary.width / 2, boundary.y + boundary.height / 2)
    canvas.rotate(boundary.angle)

    canvas.fillStyle = fill.color
    canvas.fillRect(-boundary.width / 2, -boundary.height / 2, boundary.width, boundary.height)

    if (border.width > 0) {
      canvas.lineWidth = border.width
      canvas.strokeStyle = border.color
      canvas.strokeRect(-boundary.width / 2, -boundary.height / 2, boundary.width, boundary.height)
    }

    canvas.rotate(-boundary.angle)
    canvas.translate(-boundary.x - boundary.width / 2, -boundary.y - boundary.height / 2)
    canvas.closePath()
  },

  focusRect: (canvas, { boundary }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    canvas.translate(boundary.x + boundary.width / 2, boundary.y + boundary.height / 2)
    canvas.rotate(boundary.angle)

    //drawing of border
    canvas.beginPath()
    canvas.lineWidth = 1
    canvas.setLineDash(dashedBorderType)
    canvas.strokeStyle = selectedItemBorderColor
    canvas.strokeRect(-boundary.width / 2, -boundary.height / 2, boundary.width, boundary.height)
    canvas.setLineDash([])
    canvas.closePath()

    canvas.beginPath()
    canvas.lineWidth = 1
    canvas.setLineDash(dashedBorderType)
    canvas.strokeStyle = selectedItemSecondBorderColor
    canvas.strokeRect(
      -boundary.width / 2 - 1,
      -boundary.height / 2 - 1,
      boundary.width + 2,
      boundary.height + 2,
    )
    canvas.setLineDash([])
    canvas.closePath()

    canvas.rotate(-boundary.angle)
    canvas.translate(-boundary.x - boundary.width / 2, -boundary.y - boundary.height / 2)
  },

  invertedRect: (canvas, { boundary, border }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!border) return

    //draving of area with clear rect
    canvas.beginPath()
    canvas.lineWidth = border.width
    canvas.strokeStyle = border.color
    canvas.strokeRect(boundary.x, boundary.y, boundary.width, boundary.height)
    canvas.clearRect(boundary.x, boundary.y, boundary.width, boundary.height)
    canvas.closePath()
  },

  selection: (canvas, { boundary, hasRemoveIcon }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    canvas.translate(boundary.x + boundary.width / 2, boundary.y + boundary.height / 2)
    canvas.rotate(boundary.angle)

    //drawing of border
    canvas.beginPath()
    canvas.lineWidth = 1
    canvas.strokeStyle = selectedItemBorderColor
    canvas.strokeRect(-boundary.width / 2, -boundary.height / 2, boundary.width, boundary.height)
    canvas.closePath()

    canvas.beginPath()
    canvas.lineWidth = 1
    canvas.strokeStyle = selectedItemSecondBorderColor
    canvas.strokeRect(
      -boundary.width / 2 - 1,
      -boundary.height / 2 - 1,
      boundary.width + 2,
      boundary.height + 2,
    )
    canvas.closePath()

    canvas.rotate(-boundary.angle)
    canvas.translate(-boundary.x - boundary.width / 2, -boundary.y - boundary.height / 2)

    if (hasRemoveIcon) renderers.removeButton(canvas, { boundary })
  },

  removeButton: (canvas, { boundary }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    canvas.translate(boundary.x + boundary.width / 2, boundary.y + boundary.height / 2)
    canvas.rotate(boundary.angle)

    //drawing of circle
    canvas.beginPath()
    canvas.fillStyle = deleteButtonColor
    canvas.arc(boundary.width / 2, -boundary.height / 2, deleteButtonRadius, 0, 2 * Math.PI)
    canvas.fill()
    canvas.closePath()

    //draving of 'X'
    canvas.beginPath()
    canvas.lineWidth = 2
    canvas.strokeStyle = deleteButtonLineColor
    canvas.moveTo(
      boundary.width / 2 - deleteButtonLineWidth,
      -boundary.height / 2 - deleteButtonLineWidth,
    )
    canvas.lineTo(
      boundary.width / 2 + deleteButtonLineWidth,
      -boundary.height / 2 + deleteButtonLineWidth,
    )
    canvas.moveTo(
      boundary.width / 2 + deleteButtonLineWidth,
      -boundary.height / 2 - deleteButtonLineWidth,
    )
    canvas.lineTo(
      boundary.width / 2 - deleteButtonLineWidth,
      -boundary.height / 2 + deleteButtonLineWidth,
    )
    canvas.stroke()
    canvas.closePath()

    canvas.rotate(-boundary.angle)
    canvas.translate(-boundary.x - boundary.width / 2, -boundary.y - boundary.height / 2)
  },

  resizeThumbs: (canvas, { boundary }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    //draving of area with clear rect
    canvas.beginPath()
    canvas.clearRect(boundary.x, boundary.y, boundary.width, boundary.height)
    canvas.closePath()

    renderers.resizeBorder(canvas, { boundary })
  },

  resizeBorder: (canvas, { boundary }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    //drawing dashed border background
    canvas.beginPath()
    canvas.lineWidth = dashedBorderWidth
    canvas.strokeStyle = dashedBorderBackground
    canvas.strokeRect(boundary.x + 0.5, boundary.y + 0.5, boundary.width, boundary.height)
    canvas.closePath()

    //drawing dashed border
    canvas.beginPath()
    canvas.setLineDash(dashedBorderType)
    canvas.lineWidth = dashedBorderWidth
    canvas.strokeStyle = dashedBorderColor
    canvas.strokeRect(boundary.x + 0.5, boundary.y + 0.5, boundary.width, boundary.height)
    canvas.setLineDash([])
    canvas.closePath()

    //style for corners
    canvas.strokeStyle = cornerLineColor
    canvas.lineWidth = cornerLineWidth

    //draving of top left corner
    canvas.beginPath()
    canvas.strokeRect(
      boundary.x - cornerShift,
      boundary.y - cornerShift,
      cornerLength,
      cornerLength,
    )
    canvas.closePath()

    //draving of top right corner
    canvas.beginPath()
    canvas.strokeRect(
      boundary.width + boundary.x - cornerLength + cornerShift,
      boundary.y - cornerShift,
      cornerLength,
      cornerLength,
    )
    canvas.closePath()

    //draving of bottom left corner
    canvas.beginPath()
    canvas.strokeRect(
      boundary.x - cornerShift,
      boundary.height + boundary.y - cornerLength + cornerShift,
      cornerLength,
      cornerLength,
    )
    canvas.closePath()

    // draving of bottom right corner
    canvas.beginPath()
    canvas.strokeRect(
      boundary.width + boundary.x - cornerLength + cornerShift,
      boundary.height + boundary.y - cornerLength + cornerShift,
      cornerLength,
      cornerLength,
    )
    canvas.closePath()
  },

  rotation: (canvas, { boundary, hasRotateIcon }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return
    if (!hasRotateIcon) return

    //drawing of button
    canvas.translate(boundary.x + boundary.width / 2, boundary.y + boundary.height / 2)
    canvas.rotate(boundary.angle)

    canvas.beginPath()
    canvas.strokeStyle = rotateButtonColor
    canvas.lineWidth = 2
    canvas.arc(
      -boundary.width / 2 - rotateButtonRadius,
      -boundary.height / 2 - rotateButtonRadius,
      rotateButtonRadius,
      Math.PI / 2,
      2 * Math.PI,
    )
    canvas.stroke()
    canvas.closePath()

    canvas.beginPath()
    canvas.fillStyle = rotateButtonColor
    canvas.moveTo(-boundary.width / 2 - rotateButtonRadius, -boundary.height / 2 - 4)
    canvas.lineTo(-boundary.width / 2 - rotateButtonRadius + 6, -boundary.height / 2)
    canvas.lineTo(-boundary.width / 2 - rotateButtonRadius, -boundary.height / 2 + 4)
    canvas.fill()
    canvas.closePath()

    canvas.beginPath()
    canvas.fillStyle = rotateButtonColor
    canvas.moveTo(-boundary.width / 2 - 4, -boundary.height / 2 - rotateButtonRadius)
    canvas.lineTo(-boundary.width / 2, -boundary.height / 2 - rotateButtonRadius + 6)
    canvas.lineTo(-boundary.width / 2 + 4, -boundary.height / 2 - rotateButtonRadius)
    canvas.fill()
    canvas.closePath()

    canvas.rotate(-boundary.angle)
    canvas.translate(-boundary.x - boundary.width / 2, -boundary.y - boundary.height / 2)
  },

  text: (canvas, { boundary, text, fill }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    canvas.beginPath()
    canvas.font = '16px Roboto'
    canvas.fillStyle = (fill && fill.color) || textColor

    const lines = text.split('/n')
    lines.forEach((line, index) => {
      canvas.fillText(line, boundary.x + 4, boundary.y + 18 + index * 24)
    })
    canvas.closePath()
  },

  cursor: (canvas, { boundary }) => {
    if (typeof canvas !== 'object') return
    if (!boundary) return

    canvas.beginPath()
    canvas.lineWidth = boundary.width
    canvas.strokeStyle = cursorColor

    canvas.moveTo(boundary.x, boundary.y)
    canvas.lineTo(boundary.x, boundary.y + boundary.height)
    canvas.stroke()
    canvas.closePath()
  },
}



// WEBPACK FOOTER //
// ./src/drawing/renderers/canvas.js